module.exports = __webpack_public_path__ + "static/media/intuitive.46054013.png";